import { Typography } from "@/components/ui/typography"
import { useTranslation } from "@/hooks/useTranslation/useTranslation"
import { TriangleAlert } from "lucide-react"
import { placeholderTokens } from "../setup/placeholders"

/** Marks a text field whose value still needs writing (see `needsWriting`). */
export const NEEDS_WRITING_FIELD_CLASS =
  "border-warning focus-visible:ring-warning/40"

/**
 * Under a text the org writes itself (a signature, a footer): what is still
 * a placeholder in it, so nobody sends "[Your name]" to a supplier. Follows
 * the field as it is typed in; nothing once it is written.
 */
export function PlaceholderNotice({
  id,
  text,
}: {
  /** For the field's `aria-describedby`. */
  id: string
  text: string
}) {
  const { translate } = useTranslation()
  const tokens = placeholderTokens(text)
  const empty = !text.trim()
  if (!empty && tokens.length === 0) return null

  return (
    <div
      id={id}
      className="flex items-start gap-2 rounded-md border border-warning/40 bg-warning/10 px-3 py-2"
    >
      <TriangleAlert aria-hidden className="mt-0.5 size-4 shrink-0" />
      <Typography as="small" className="font-normal">
        {empty
          ? translate("SETTINGS/SETUP/EMPTY_NOTICE")
          : translate("SETTINGS/SETUP/PLACEHOLDER_NOTICE", {
              placeholders: tokens.join(", "),
            })}
      </Typography>
    </div>
  )
}
